/* CasaKiubo: load motion only when visible; keep posters and links usable without JS. */
(() => {
  const selector = 'video[data-ck-video-src]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const visible = new Set();
  const waitingForPrimary = new WeakSet();
  function play(video) {
    if (document.hidden || reducedMotion.matches || navigator.connection?.saveData) return;
    // Decorative branding waits for the product/hero image, keeping its bandwidth first.
    if (!video.getAttribute('src')) {
      const primary = document.querySelector('.ck-initial-slide img[fetchpriority="high"], .ck-navidad-hero__image, .cq-xmas-hero-art');
      if (primary && !primary.complete) {
        if (!waitingForPrimary.has(video)) {
          waitingForPrimary.add(video);
          const resume = () => { if (visible.has(video)) requestAnimationFrame(() => play(video)); };
          primary.addEventListener('load', resume, {once: true});
          primary.addEventListener('error', resume, {once: true});
        }
        return;
      }
    }
    if (!video.getAttribute('src')) video.src = video.dataset.ckVideoSrc;
    video.muted = true;
    video.play().catch(() => {});
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) { visible.add(entry.target); play(entry.target); }
      else { visible.delete(entry.target); entry.target.pause(); }
    }
  }, { rootMargin: '0px', threshold: 0.1 }) : null;
  function init(root) {
    const videos = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    for (const video of videos) {
      if (observed.has(video)) continue;
      observed.add(video);
      const start = Number(video.dataset.ckVideoStart || 0);
      if (start > 0) video.addEventListener('loadedmetadata', () => {
        if (start < video.duration) video.currentTime = start;
      }, {once: true});
      video.addEventListener('playing', () => video.classList.add('ck-motion-playing'));
      if (observer) observer.observe(video);
      else { visible.add(video); play(video); }
    }
  }
  init(document);
  document.addEventListener('visibilitychange', () => {
    for (const video of visible) document.hidden ? video.pause() : play(video);
  });
  reducedMotion.addEventListener('change', () => {
    for (const video of visible) reducedMotion.matches ? video.pause() : play(video);
  });
  // Recommendations and Shopify section rendering can insert new product cards.
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) init(node);
  }).observe(document.body, {childList: true, subtree: true});
})();
